import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import logo2 from "./img/saitacity2.png"
import saitareality from './img/head1.png'
import saita from './img/head-2.png'
import paper from './img/paper.png'
import vid1 from './img/1.mp4'
import vid2 from './img/2.mp4'

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: #b342b5;
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: var(--primary);
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });


  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    if (mintAmount === 10) return;
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);
  return (
    <>
      <div className="preloader">
        <img src="./images/saitacity2.png" alt="Apes land" style={{ width: "20%" }} />
      </div>
      <header className="header-section">
        <div className="header-bottom">
          <div className="container">
            <div className="header-wrapper">
              <div className="logo">
              </div>
              <div className="menu-area">
                <div className="header-btn d-flex justify-content-end text-center">
                  <a href="https://www.saitarealty.com" target="_blank">
                    <img src={saitareality} alt="saita" style={{ width: "50%" }} />
                  </a>



                  <a href="https://www.saitamatoken.com" target="_blank">
                    <img src={saita} alt="saita" style={{ width: "50%" }} />
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </header>
      <section id="home" className="banner banner--2">
        <div className="container">
          <div className="banner__wrapper">
            <div className="row g-5 align-items-center">
              <div className="col-lg-6">
                <div className="banner__content" s>
                  <img className="saitacity" src="./images/saitacity2.png" alt="image" style={{ width: "40%" }} />
                  <br /><br /><br />
                  <h3 className="nBold" style={{ fontSize: "30px", fontFamily: "nblod" }}>Secure Your Presale Copy,
                    Be One Of The First SaitaCitizens

                  </h3> <br />
                  <p className="nLight" style={{ fontWeight: "100" }}>
                    SaitaCity is a real estate market simulation game in development by Saitama. Players will be able to build and trade meta property to earn profit, badges, and <a href="https://www.saitarealty.com" target="_blank" style={{ color: "skyblue" }}>Saita Realty DAO</a>  governance power. We are proud to launch this inaugural collection of buildings that can be used in the game upon its release.
                    Watch the trailer

                    NFT presales help expedite the platform’s development during this bear market, thus benefiting the whole community. Please
                    <a href="https://saitarealty.gitbook.io/saitarealty-dao/" target="_blank" style={{ color: "skyblue" }}> read our whitepaper</a> for more information on SaitaCity and our aspirational goals.

                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="neon-one text-center" style={{ position: "relative", marginTop: "-40px", marginBottom: "60px", background: "#ef7b30", borderRadius: "30px", padding: "12px 24px", width: "fit-content" }}>
                  <p className="neon-one">NFT PRE SALE</p>
                </div>
                <div className=" d-flex" id="round-card" >
                  <div className="team__item--style2" style={{
                    background: "none"
                  }}>
                    <div className="">
                      <div className="team__item-thumb">
                        {/* <img src=" gifs/saitacity.gif " alt=" Team Image " style={{ borderRadius: "20px", width: "1200px", height: "540px" }} /> */}
                        <video autoPlay="true" loop controls style={{ width: "inherit", borderRadius: "20px", }}>
                          <source id="arrows" src={vid1} type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="d-flex justify-content-center">
        <div className="neon-one " style={{ position: "relative", background: "#ef7b30", borderRadius: "30px", padding: "10px" }}>
          <p className="neon-one text-center">COLLECTION #002</p>
        </div>
      </section>
      <section className="d-flex justify-content-center">
        <img src={paper} alt="paper logo" width="50%" />

      </section>
      <div style={{
        maxWidth: "1280px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto"
      }}>
        <p className="village text-center nLight" style={{ padding: "20px", paddingLeft: "60px", paddingRight: "60px", lineHeight: "1.6", fontSize: "1.4rem" }} >
          Our second collection, Paper Village, is a new zone in SaitaCity featuring houses entirely
          made of paper craft. The collection contains 333 unique models of different types of houses,
          designed to be playful and imaginative. It is a hub for creativity and imagination, and it's a great
          place to settle, spend time with loved ones and create memories. Experience the childhood dream of
          residing in the houses you always imagined.This Paper Village collection comes with a 20% boost in SCPs,
          the points needed for SaitaRealty DAO governance; and the first ever citizen badge in SaitaCity which will
          give holders special status.
        </p>
      </div>
      <section className=" about padding-top padding-bottom bg--semi-body" id="about">
        <div className=" container ">
          <div className=" about__wrapper">
            <div className=" row align-items-center g-5 ">
              <div className="col-xl-6 col-lg-12">
                <div className=" about__content">
                  <div className="banner__thumb d-flex" id="round-card">
                    <div className="team__item team__item--style2" style={{ padding: "10px" }}>
                      <div className="team__item-inner">
                        <div className="team__item-thumb">
                          <div className="neon-2">
                            <h2 className="neon">MINT NFT</h2>
                            <h6>{data.totalSupply} / {CONFIG.MAX_SUPPLY}</h6>
                            <input id="input-one" type="number" className="p-3 placeholder:text-white" placeholder="Balance" disabled style={{
                              width: "500px", background: "none", fontSize: "20px",
                              boxShadow: "none", border: "none", color: "white", borderBottom: "2px solid #fff"
                            }} />

                            <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: "2px solid white" }}>
                              <span style={{ fontSize: "20px", fontWeight: "900" }}>
                                Amount
                              </span>
                              <div className="d-flex gap-2">
                                <StyledRoundButton
                                  style={{ lineHeight: 0.4 }}
                                  disabled={claimingNft ? 1 : 0}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    decrementMintAmount();
                                  }}
                                >
                                  -
                                </StyledRoundButton>

                                <span style={{ padding: "12px" }}>{mintAmount}</span>
                                <StyledRoundButton
                                  disabled={claimingNft ? 1 : 0}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    incrementMintAmount();
                                  }}
                                >
                                  +
                                </StyledRoundButton>
                              </div>
                              <button className="max" style={{
                                background: "#fff", paddingLeft: "20px", color: "black",
                                paddingRight: "20px", paddingTop: "8px", paddingBottom: "8px", borderRadius: "4px", cursor: "pointer"


                              }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setMintAmount(10);
                                }}

                              >
                                Max
                              </button>
                            </div>
                            <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: "2px solid white" }}>
                              <span style={{ fontSize: "20px", fontWeight: "900" }}>
                                Total
                              </span>
                              <div className="d-flex gap-2">
                                <span></span>

                                <span></span>
                              </div>
                              <span className="max" style={{ paddingLeft: "20px", color: "#fff", paddingRight: "20px", paddingTop: "8px", paddingBottom: "8px", borderRadius: "4px", cursor: "pointer" }}>
                                {mintAmount * 0.4} {CONFIG.NETWORK.SYMBOL}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className=" team__item-content ">
                          <div className=" team__item-author " style={{ borderRadius: "4px" }}>
                            <div className=" d-flex justify-content-center gap-2">
                              <>
                                {blockchain.account === "" ||
                                  blockchain.smartContract === null ? (
                                  <s.Container ai={"center"} jc={"center"}>
                                    <s.TextDescription
                                      style={{
                                        textAlign: "center",
                                        color: "var(--accent-text)",
                                      }}
                                    >
                                      Connect to the {CONFIG.NETWORK.NAME} network
                                    </s.TextDescription>
                                    <s.SpacerSmall />
                                    <StyledButton
                                      onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(connect());
                                        getData();
                                      }}
                                    >
                                      CONNECT
                                    </StyledButton>
                                  </s.Container>
                                ) : (
                                  <>
                                    <s.TextDescription
                                      style={{
                                        textAlign: "center",
                                        color: "var(--accent-text)",
                                      }}>
                                      {feedback}
                                    </s.TextDescription>

                                    <s.SpacerSmall />
                                    <StyledButton
                                      disabled={claimingNft ? 1 : 0}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        claimNFTs();
                                        getData();
                                      }}>
                                      {claimingNft ? "BUSY" : "BUY"}
                                    </StyledButton>

                                  </>
                                )}
                              </>

                            </div>
                          </div>
                          {blockchain.errorMsg !== "" ? (
                            <>
                              <s.SpacerSmall />
                              <s.TextDescription
                                style={{
                                  textAlign: "center",
                                  color: "red",
                                }}
                              >
                                {blockchain.errorMsg}
                              </s.TextDescription>
                            </>
                          ) : null}
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12">
                <div className="">
                  <div className=" row g-4 ">
                    <div className="team__item team__item--style2 " style={{
                      paddingTop: "6px", paddingBottom: "6px",
                      paddingLeft: "20px", paddingRight: "20px", background: "none"
                    }}>
                      <div className="team__item-inner">
                        <div className="card-last">
                          {/* <img src=" gifs/main.gif " alt=" Team Image " style={{ borderRadius: "20px", width: "1020px", height: "380px" }} /> */}
                          <video autoPlay="true" loop controls preLoad="auto" style={{ width: "520px", borderRadius: "20px", }}>
                            <source id="arrows" src={vid2} type="video/mp4" />
                          </video>
                        </div>
                        <div className=" team__item-content ">
                          <div className=" team__item-author ">
                            <div className=" d-flex justify-content-center" style={{ padding: "6px", }}>
                              <p className="nLight" style={{ lineheight: "1.6" }}>Samples from the 333 unique NFTs. Please note that the NFTs will appear in your wallet in 2D but will be visualized in 3D inside SaitaCity. Maximum of 10 NFTs per transaction.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className=" footer " style={{ background: "#b342b5" }}>
        <div className=" footer__copyright ">
          <div className=" container ">
            <div className="d-flex justify-content-end">
              <p className="" style={{ marginTop: "30px", marginRight: "10px" }}>Powered By </p>
              <a href="https://fang.art/" target="_blank">
                <img className="" src="./images/logo.svg" alt="" style={{ width: "100%", marginRight: "20px" }} />
              </a>

            </div>
          </div>
        </div>
      </footer>













      {/* <s.Screen>
        <s.Container
          flex={1}
          ai={"center"}
          style={{ padding: 24, backgroundColor: "var(--primary)" }}
          image={CONFIG.SHOW_BACKGROUND ? "/config/./images/bg.png" : null}>
          <a href={CONFIG.MARKETPLACE_LINK}>
            <StyledLogo alt={"logo"} src={logo2} />
          </a>
          <s.SpacerSmall />
          <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
            <s.Container flex={1} jc={"center"} ai={"center"}>
              <StyledImg alt={"example"} src={"/config/./images/example.gif"} />
            </s.Container>
            <s.SpacerLarge />
            <s.Container
              flex={2}
              jc={"center"}
              ai={"center"}
              style={{
                backgroundColor: "var(--accent)",
                padding: 24,
                borderRadius: 24,
                border: "4px dashed var(--secondary)",
                boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
              }}>
              <s.TextTitle
                style={{
                  textAlign: "center",
                  fontSize: 50,
                  fontWeight: "bold",
                  color: "var(--accent-text)",
                }}>
                {data.totalSupply} / {CONFIG.MAX_SUPPLY}
              </s.TextTitle>
              <s.TextDescription
                style={{
                  textAlign: "center",
                  color: "var(--primary-text)",
                }}>
                <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK}>
                  {truncate(CONFIG.CONTRACT_ADDRESS, 15)}
                </StyledLink>
              </s.TextDescription>
              <span
                style={{
                  textAlign: "center",
                }}>
                <StyledButton
                  onClick={(e) => {
                    window.open("/");
                  }}
                  style={{
                    margin: "5px",
                  }}>
                  Roadmap
                </StyledButton>
                <StyledButton
                  style={{
                    margin: "5px",
                  }}
                  onClick={(e) => {
                    window.open(CONFIG.MARKETPLACE_LINK, "_blank");
                  }}>
                  {CONFIG.MARKETPLACE}
                </StyledButton>
              </span>
              <s.SpacerSmall />
              {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
                <>
                  <s.TextTitle
                    style={{ textAlign: "center", color: "var(--accent-text)" }}>
                    The sale has ended.
                  </s.TextTitle>
                  <s.TextDescription
                    style={{ textAlign: "center", color: "var(--accent-text)" }}>
                    You can still find {CONFIG.NFT_NAME} on
                  </s.TextDescription>
                  <s.SpacerSmall />
                  <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                    {CONFIG.MARKETPLACE}
                  </StyledLink>
                </>
              ) : (
                <>
                  <s.TextTitle
                    style={{ textAlign: "center", color: "var(--accent-text)" }}>
                    1 {CONFIG.SYMBOL} costs {CONFIG.DISPLAY_COST}{" "}
                    {CONFIG.NETWORK.SYMBOL}.
                  </s.TextTitle>
                  <s.SpacerXSmall />
                  <s.TextDescription
                    style={{ textAlign: "center", color: "var(--accent-text)" }}>
                    Excluding gas fees.
                  </s.TextDescription>
                  <s.SpacerSmall />
                  {blockchain.account === "" ||
                    blockchain.smartContract === null ? (
                    <s.Container ai={"center"} jc={"center"}>
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                        }}
                      >
                        Connect to the {CONFIG.NETWORK.NAME} network
                      </s.TextDescription>
                      <s.SpacerSmall />
                      <StyledButton
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(connect());
                          getData();
                        }}
                      >
                        CONNECT
                      </StyledButton>
                      {blockchain.errorMsg !== "" ? (
                        <>
                          <s.SpacerSmall />
                          <s.TextDescription
                            style={{
                              textAlign: "center",
                              color: "var(--accent-text)",
                            }}
                          >
                            {blockchain.errorMsg}
                          </s.TextDescription>
                        </>
                      ) : null}
                    </s.Container>
                  ) : (
                    <>
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                        }}>
                        {feedback}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <s.Container ai={"center"} jc={"center"} fd={"row"}>
                        <StyledRoundButton
                          style={{ lineHeight: 0.4 }}
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            decrementMintAmount();
                          }}>
                          -
                        </StyledRoundButton>
                        <s.SpacerMedium />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}>
                          {mintAmount}
                        </s.TextDescription>
                        <s.SpacerMedium />
                        <StyledRoundButton
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            incrementMintAmount();
                          }}>
                          +
                        </StyledRoundButton>
                      </s.Container>
                      <s.SpacerSmall />
                      <s.Container ai={"center"} jc={"center"} fd={"row"}>
                        <StyledButton
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            claimNFTs();
                            getData();
                          }}>
                          {claimingNft ? "BUSY" : "BUY"}
                        </StyledButton>
                      </s.Container>
                    </>
                  )}
                </>
              )}
              <s.SpacerMedium />
            </s.Container>
            <s.SpacerLarge />
            <s.Container flex={1} jc={"center"} ai={"center"}>
              <StyledImg
                alt={"example"}
                src={"/config/./images/example.gif"}
                style={{ transform: "scaleX(-1)" }} />
            </s.Container>
          </ResponsiveWrapper>
          <s.SpacerMedium />
          <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary-text)",
              }}>
              Please make sure you are connected to the right network (
              {CONFIG.NETWORK.NAME} Mainnet) and the correct address. Please note:
              Once you make the purchase, you cannot undo this action.
            </s.TextDescription>
            <s.SpacerSmall />
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary-text)",
              }}>
              We have set the gas limit to {CONFIG.GAS_LIMIT} for the contract to
              successfully mint your NFT. We recommend that you don't lower the
              gas limit.
            </s.TextDescription>
          </s.Container>
        </s.Container>
      </s.Screen> */}
    </>
  );
}

export default App;
